import { IFormTypeService } from "../../service/formconfiguration/FormTypeService";

export default class RemoveEvaluationTypeFromFormTypeInteractor {
  private formTypeService: IFormTypeService;

  constructor(formTypeService) {
    this.formTypeService = formTypeService;
  }

  async execute(formTypeReviewId: number) {
    return this.formTypeService.removeEvaluationTypeFromFormType(
      formTypeReviewId
    );
  }
}
